import { render, staticRenderFns } from "./quickReplyBox.vue?vue&type=template&id=4404c5ed&scoped=true&"
import script from "./quickReplyBox.vue?vue&type=script&lang=js&"
export * from "./quickReplyBox.vue?vue&type=script&lang=js&"
import style0 from "./quickReplyBox.vue?vue&type=style&index=0&id=4404c5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4404c5ed",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
